import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/elements/email.svg")